import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tabAll", "tabUnread", "list"]

  showAll() {
    this.setActiveTab(this.tabAllTarget, this.tabUnreadTarget)
    this.filterItems(false)
  }

  showUnread() {
    this.setActiveTab(this.tabUnreadTarget, this.tabAllTarget)
    this.filterItems(true)
  }

  setActiveTab(active, inactive) {
    active.style.color = "#6366F1"
    active.style.fontWeight = "600"
    active.style.borderBottomColor = "#6366F1"

    inactive.style.color = "#9CA3AF"
    inactive.style.fontWeight = "500"
    inactive.style.borderBottomColor = "transparent"
  }

  filterItems(unreadOnly) {
    const items = this.listTarget.querySelectorAll("[data-read]")
    items.forEach(item => {
      if (unreadOnly && item.dataset.read === "true") {
        item.style.display = "none"
      } else {
        item.style.display = "flex"
      }
    })
  }
}
